import { useRecoilValue } from 'recoil';
import songState from 'store/song';

const useNowPlaying = () => {
  const songs = useRecoilValue(songState);
  const name = songs.at(-1)?.name || '';
  const splitIndex = name.lastIndexOf(' by ');
  const songName = splitIndex > 0 ? name.substring(0, splitIndex) : name;
  const singer = splitIndex > 0 ? name.substring(splitIndex + 4) : '';

  return { songName, singer, isSingleLine: !singer };
};

export default useNowPlaying;
